var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({staticClass:"icon cursor-pointer",attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":("#" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }